/**
 * Textos (`es`) del Recuento de existencias del BackOffice (OBR-147). Mismas claves que `count.ca.ts` (i18n.test.ts). Vocabulario:
 * «Recuento de existencias» (nunca «inventario»); «Existencias» (nunca «Stock»).
 */

export const countEs = {
  'backoffice.stockCounts': {
    // La lista
    title: 'Recuentos de existencias',
    subtitle:
      'Cuenta las existencias reales, compáralas con las teóricas y ajusta las diferencias.',
    create: 'Nuevo recuento',
    searchLabel: 'Buscar',
    filterStatus: 'Estado',
    filterScope: 'Alcance',
    filterFrom: 'Desde el',
    filterTo: 'Hasta el',
    allStatuses: 'Todos los estados',
    allScopes: 'Todos los alcances',
    status_open: 'Abierto',
    status_validated: 'Validado',
    status_cancelled: 'Cancelado',
    scope_tenant: 'Todo el obrador',
    scope_zone: 'Zona',
    scope_section: 'Sección',
    scope_location: 'Ubicación',
    scope_article: 'Artículo',
    scopeOf_tenant: 'Todo el obrador',
    scopeOf_zone: 'Zona {{name}}',
    scopeOf_section: 'Sección {{name}}',
    scopeOf_location: 'Ubicación {{name}}',
    scopeOf_article: 'Artículo {{name}}',
    scopeUnknown: '—',
    colNumber: 'Número',
    colScope: 'Alcance',
    colStatus: 'Estado',
    colProgress: 'Líneas',
    colDate: 'Fecha',
    colBy: 'Creado por',
    progressOpen: '{{counted}} de {{total}} contadas',
    progressValidated: '{{adjusted}} ajustadas de {{total}}',
    progressCancelled: '{{total}} líneas sin ajustar',
    empty: 'Todavía no hay ningún recuento. Crea uno para contar las existencias reales.',
    emptyFiltered: 'Ningún recuento coincide con los filtros.',
    loadError: 'No se han podido cargar los recuentos. Vuelve a intentarlo.',
    listLimit: 'Se muestran los {{count}} recuentos más recientes.',
    unknownPerson: '—',

    // El diálogo de creación
    createTitle: 'Nuevo recuento de existencias',
    createBody:
      'Se guarda una fotografía de las existencias teóricas del alcance elegido, lote a lote y lugar a lugar. Las existencias no se bloquean mientras cuentas: los movimientos continúan.',
    createScopeLabel: '¿Qué quieres contar?',
    createZoneLabel: 'Zona',
    createSectionLabel: 'Sección',
    createLocationLabel: 'Ubicación',
    createArticleLabel: 'Artículo',
    createTargetPlaceholder: 'Elige uno',
    createNoTargets: 'Todavía no hay nada de este tipo en la estructura del obrador.',
    createNoteLabel: 'Nota (opcional)',
    createNotePlaceholder: 'Por ejemplo: recuento de cierre de mes',
    createConfirm: 'Crea el recuento',

    // La pantalla del recuento
    back: 'Todos los recuentos',
    notFound: 'Este recuento no existe o no puedes verlo.',
    detailLoadError: 'No se ha podido cargar el recuento. Vuelve a intentarlo.',
    linesLoadError: 'No se han podido cargar las líneas del recuento. Vuelve a intentarlo.',
    createdBy: 'Creado por {{name}} el {{date}}',
    validatedBy: 'Validado por {{name}} el {{date}}',
    cancelledBy: 'Cancelado por {{name}} el {{date}}',
    cancelReasonLine: 'Motivo: {{reason}}',
    noteLine: 'Nota: {{note}}',
    validate: 'Valida el recuento',
    cancel: 'Cancela el recuento',
    addFound: 'Añade un lote encontrado',
    filterAll: 'Todas',
    filter_pending: 'Pendientes',
    filter_match: 'Coincide',
    filter_short: 'Falta',
    filter_over: 'Sobra',
    filterAria: 'Filtra las líneas por el resultado del recuento',
    state_pending: 'Sin contar',
    state_match: 'Coincide',
    state_short: 'Falta',
    state_over: 'Sobra',
    stateShortQuantity: 'Falta {{quantity}} {{unit}}',
    stateOverQuantity: 'Sobra {{quantity}} {{unit}}',
    colLot: 'Lote',
    colPlace: 'Lugar',
    colTheoretical: 'Teórica',
    colNow: 'Ahora',
    colAtValidation: 'Al validar',
    colCounted: 'Contada',
    colDifference: 'Diferencia',
    colAdjustment: 'Ajuste',
    noLot: 'Sin lote',
    noPlace: 'Sin lugar',
    expiresOn: 'Caduca el {{date}}',
    noExpiry: 'Sin caducidad',
    newLotTag: 'Lote nuevo',
    foundTag: 'Encontrado',
    changedTag: 'Ha cambiado',
    changedHint:
      'Ahora hay {{quantity}} {{unit}}: alguien ha movido existencias de este lote desde que se creó el recuento.',
    currentLoading: 'Leyendo las existencias de ahora…',
    currentError:
      'No se han podido leer las existencias de ahora. El recuento se puede continuar, pero no se avisará si han cambiado.',
    confirmTheoretical: 'Confirma teórica',
    confirmGroup: 'Confirma teórica del grupo',
    confirmNegative: 'Un saldo negativo no se puede confirmar: cuéntalo de verdad.',
    countedAria: 'Cantidad contada de {{article}}, lote {{lot}}',
    countedInvalid: 'Escribe una cantidad válida (0 o más).',
    saving: 'Guardando…',
    saved: 'Todo guardado',
    saveError: 'No se ha podido guardar lo que has escrito. Vuelve a intentarlo.',
    saveRetry: 'Vuelve a intentarlo',
    groupLines: '{{count}} líneas',
    warnChanged:
      'La teórica ha cambiado en {{count}} líneas desde que se creó el recuento. Al validar, el ajuste se calcula sobre las existencias de ahora, no sobre la fotografía.',
    warnPending: 'Hay {{count}} líneas sin contar: no se tocarán al validar.',
    validatedBanner:
      'Recuento validado: {{adjusted}} ajustes, {{matched}} líneas coinciden y {{lots}} lotes nuevos.',
    readOnlyValidated: 'Este recuento está validado y ya no se puede editar.',
    readOnlyCancelled: 'Este recuento está cancelado y no ha ajustado nada.',
    emptyLines:
      'Este alcance no tenía existencias en la fotografía. Puedes añadir los lotes que encuentres.',
    noLinesFiltered: 'Ninguna línea coincide con este filtro.',
    adjustmentNone: 'Sin ajuste',
    adjustmentNotCounted: 'No contada',
    viewMovements: 'Muestra los movimientos',

    // La validación
    validateTitle: 'Valida el recuento',
    validateBody:
      'Se generará un movimiento de ajuste con el motivo «Recuento» por cada línea con diferencia. Una vez validado, el recuento ya no se puede editar.',
    validateSummaryAdjust:
      '{{count}} ajustes: {{increases}} sobran, {{decreases}} faltan y {{lots}} lotes nuevos.',
    validateNothing: 'No hay ninguna diferencia: no se generará ningún movimiento.',
    validateMatched: '{{count}} líneas coinciden y no generan ningún movimiento.',
    validateNotCounted: '{{count}} líneas sin contar: no se tocarán.',
    validateChanged:
      '{{count}} líneas con la teórica cambiada: el ajuste se calcula sobre las existencias de ahora.',
    validateBlocked: 'Estas líneas no se pueden ajustar tal como están:',
    validateBlockedHint: 'Corrígelas antes de validar.',
    validateAdjustmentsTitle: 'Ajustes que se crearán',
    validateAdjustLine: '{{article}} · {{lot}} · {{place}}: {{from}} → {{to}} ({{delta}} {{unit}})',
    validateNewLotLine: '{{article}} · lote nuevo · {{place}}: {{to}} {{unit}}',
    validateMore: 'y {{count}} más',
    validateConfirm: 'Valida y ajusta',
    validateCurrentLoading: 'Leyendo las existencias de ahora…',
    validateCurrentError:
      'No se han podido leer las existencias de ahora. Puedes validar igualmente: el servidor lo comprueba.',
    validateFailedLine: 'Línea {{article}} · {{lot}} · {{place}}: {{message}}',

    // La cancelación
    cancelTitle: 'Cancela el recuento',
    cancelBody: 'El recuento queda cancelado y no se ajusta nada. Hay que escribir el motivo.',
    cancelLabel: 'Motivo de la cancelación',
    cancelPlaceholder: 'Por ejemplo: nos hemos equivocado de alcance',
    cancelConfirm: 'Cancela el recuento',

    // Añadir un lote encontrado
    foundTitle: 'Añade un lote encontrado',
    foundBody:
      'Un lote que has encontrado y no estaba en la fotografía. Si ya existe en el sistema, elígelo; si no, se creará como lote nuevo de ajuste cuando valides.',
    foundArticle: 'Artículo',
    foundArticlePlaceholder: 'Busca un artículo',
    foundMode: 'Tipo de lote',
    foundModeExisting: 'Un lote que ya existe',
    foundModeNew: 'Un lote nuevo',
    foundLot: 'Lote',
    foundLotPlaceholder: 'Elige un lote',
    foundLotsLoading: 'Leyendo los lotes…',
    foundLotsError: 'No se han podido leer los lotes de este artículo.',
    foundNoLots: 'Este artículo todavía no tiene lotes: elige «Un lote nuevo».',
    foundCode: 'Código de lote del proveedor (opcional)',
    foundExpiry: 'Caducidad',
    foundExpiryRequired: 'Obligatoria para este artículo.',
    foundExpiryOptional: 'Opcional.',
    foundExpiryInvalid: 'Escribe una fecha válida.',
    foundPlace: 'Lugar',
    foundPlaceHint: 'Tiene que estar dentro del alcance del recuento.',
    foundPlaceRequired: 'Elige un lugar.',
    foundQuantity: 'Cantidad contada ({{unit}})',
    foundQuantityBare: 'Cantidad contada',
    foundQuantityInvalid: 'Escribe una cantidad válida.',
    foundNote: 'Nota (opcional)',
    foundConfirm: 'Añade',
    foundProduction:
      'Este artículo solo se produce: su lote lo crea una orden de trabajo. Elige un lote que ya exista.',
    foundNoTracked: 'Este artículo no lleva control de existencias.',

    // 2.ª pasada: confirmar con el saldo de ahora, caducidad de un lote existente, lote creado, validación con todo guardado
    confirmCurrent: 'Confirma el de ahora',
    confirmCurrentHint:
      'Ha cambiado desde la fotografía: se confirman las {{quantity}} {{unit}} de ahora, no las de la foto.',
    confirmGroupCurrentHint:
      '{{count}} líneas han cambiado desde la fotografía: se confirma su saldo de ahora, no el de la foto.',
    lotExpiryLabel: 'Caducidad del lote',
    lotExpiryHint:
      'Este lote no tiene y el recuento le añade existencias: indícala para poder validar.',
    lotExpiryAria: 'Caducidad del lote {{lot}} de {{article}}',
    lotCreatedTag: 'Lote creado',
    validatePreparing: 'Guardando las cantidades y leyendo el estado actual del recuento…',
    validateUnsaved:
      'Hay cantidades que no se han podido guardar: sin eso, el resumen no sería lo que se validará.',
    validateRetry: 'Vuelve a intentarlo',
    leaveTitle: 'Hay cantidades sin guardar',
    leaveBody:
      'No se han podido guardar las cantidades que has escrito. Si sales ahora, se perderán.',
    leaveConfirm: 'Salir igualmente',

    // Un lote encontrado que ya está en el recuento
    foundExistsTitle: 'Este lote ya está en el recuento en este lugar',
    foundExistsCounted: 'Ya tienes contadas {{quantity}} {{unit}}.',
    foundExistsPending: 'Todavía no lo has contado.',
    foundExistsChoice: '¿Qué hacemos con lo que ya estaba contado?',
    foundExistsAddShort: 'Súmalo',
    foundExistsReplaceShort: 'Sustitúyelo',
    foundExistsAdd: 'Súmalo: {{from}} + {{quantity}} = {{to}} {{unit}}',
    foundExistsReplace: 'Sustitúyelo: quedan {{to}} {{unit}}',
    foundExpiryExistingRequired:
      'Este lote no tiene caducidad y el artículo la pide: indícala para que se pueda ajustar.',
    foundLotsTruncated:
      'Solo se muestran los {{limit}} lotes más nuevos. Escribe el número del lote para buscarlo.',
    foundLotSearch: 'Busca un lote por el número',
    foundLotSearchPlaceholder: 'Por ejemplo: MP-L-00042',

    // Crear un recuento: la estructura no se ha podido leer
    createStructureError:
      'No se ha podido leer la estructura del obrador (zonas, secciones y ubicaciones): sin eso no se puede elegir un alcance de estructura.',
    createStructureRetry: 'Vuelve a intentarlo',

    // Errores de las RPC
    errForbidden: 'No tienes permiso para hacer recuentos de existencias.',
    errBadScope: 'El alcance elegido no es válido.',
    errTooLarge:
      'El alcance tiene demasiadas líneas. Elige una zona, una sección, una ubicación o un artículo.',
    errClientUuidConflict:
      'Esta operación ya se había hecho con otros datos. Vuelve a abrir el diálogo e inténtalo de nuevo.',
    errNotFound: 'Este recuento no existe o no puedes verlo.',
    errNotOpen: 'Este recuento ya no está abierto: quizá alguien lo ha validado o cancelado.',
    errBadLine: 'Una de las líneas no es válida.',
    errBadQuantity: 'La cantidad no es válida: tiene que ser 0 o más.',
    errUnknownLine: 'Una de las líneas ya no es de este recuento. Recarga la pantalla.',
    errUnknownArticle: 'Este artículo no existe, está de baja o no lleva control de existencias.',
    errUnknownLot: 'Este lote no es de este artículo.',
    errBadPlace: 'Este lugar no es del obrador.',
    errOutOfScope: 'Este lugar está fuera del alcance del recuento.',
    errLotRequired: 'Hay que indicar un lote (uno que ya exista o uno nuevo).',
    errReasonRequired: 'Hay que escribir el motivo.',
    errImmutable: 'Un recuento validado o cancelado no se puede modificar.',
    errGeneric: 'No se ha podido hacer. Vuelve a intentarlo.',
  },
} as const;
